/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Base from './base'
import RegistrationInfo from './registration_info'
import $ from 'jquery'
import URI from 'urijs'

export default class Presenter extends Base {
  initialize (options) {
    this.registrationInfo = new RegistrationInfo(options)

    return this.on('change:login', (model, login) => {
      return this.updateLogin(login)
    })
  }

  url () {
    return URI('/api/users').segment(this.get('login')).toString()
  }

  updateLogin (login) {
    // blow away any existing registration info
    this.registrationInfo.clear()

    // reset the login
    return this.registrationInfo.set({ login })
  }

  fetch (opts = {}) {
    this.updateLogin(this.get('login'))

    return $.when(super.fetch(opts), this.registrationInfo.fetch(opts))
  }
}
